import { useQuery } from '@tanstack/react-query';
import type { SupportDTO } from '@meshsmith/shared';
import { api } from '../lib/api';

/** The phone numbers and opening hours shown to customers, as set by staff. Changes rarely, so it is cached. */
export function useSupport(): SupportDTO {
  const { data } = useQuery({
    queryKey: ['support'],
    queryFn: () => api.get<SupportDTO>('/content/support'),
    staleTime: 10 * 60 * 1000,
  });
  return data ?? { phones: [], hours: '' };
}
